module.exports = __webpack_public_path__ + "img/back.b1728ef3.jpg";